import { render, staticRenderFns } from "./EnvBanner.vue?vue&type=template&id=b57817a4"
import script from "./EnvBanner.vue?vue&type=script&lang=js"
export * from "./EnvBanner.vue?vue&type=script&lang=js"
import style0 from "./EnvBanner.vue?vue&type=style&index=0&id=b57817a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports